export default [
  { value: "user", name: "Standard user" },
  { value: "admin", name: "Admin" },
]



// WEBPACK FOOTER //
// ./src/config/data/user_roles.js